import { render, staticRenderFns } from "./WikiContentTeaser.vue?vue&type=template&id=eadbe934&scoped=true&"
import script from "./WikiContentTeaser.vue?vue&type=script&lang=js&"
export * from "./WikiContentTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadbe934",
  null
  
)

export default component.exports